import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { getCurrentUser, inObject } from 'app/utils/helpers';
import { IMyOptions } from 'mydatepicker';
import { constant } from '../../../../app.constants';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { GoogleMapsComponent } from '../../../A2-utils/google-maps/google-maps.component';
import { CatchingErrorsService } from '../../../A2-utils/ParentClass/catching-errors.service';
import { AutoSchedulerService } from '../../../auto-scheduler/auto-scheduler.service';
import { CallTypesService } from '../../../call-types/call-types.service';
import { CompaniesService } from '../../../companies/companies.service';
import { DriversService } from '../../../drivers/drivers.service';
import { OnDemandDriversService } from '../../../on-demand-drivers/on-demand-drivers.service';
import { PayorsService } from '../../../payors/payors.service';
import { ProvidersService } from '../../../providers/providers.service';
import { RiderService } from '../../../riders/rider.service';
import { VehiclesService } from '../../../vehicles/vehicles.service';
import { ReservationNoteListComponent } from '../../reservation-notes/reservation-note-list/reservation-note-list.component';
import { ReservationService } from '../../reservations.service';
import { TripModelR } from '../../trip.model';
import { TripLocationModel } from '../../triplocation.model';
import { inputsFrom } from './controls-form';
import { Observable } from 'rxjs/Observable';
import { IDropoffServiceProvider } from '../../../../core/interfaces/dropoff-service-provider.interface';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/finally';
import { assignNewArray, resetServiceEnabled, verifyServiceEnabled } from '../../../A2-utils/export-functions/functions-services';
import { DepotService } from '../../../../core/services/depot.service';
import { DepotModel } from '../../../../core/models/depot.model';
import { IRiderPayor } from '../../../../core/interfaces/rider-payor.interface';
import { ICompanyProvider } from '../../../../core/interfaces/companies.interface';
import { IReasonDelay } from '../../../../core/interfaces/reasons-delay.interface';
import { ReasonsDelayService } from '../../../../core/services/reasons-delay.service';
import { ICallTypeResponse } from '../../../../core/interfaces/call-type.interface';
import { CompaniesEnum } from 'app/core/enums/companies.enum';
import { ProvidersBillingService } from '../../../providers-billing/providers-billing-service.service';
import { TripStatusEnum } from 'app/core/enums/trips-status.enum';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { PayorEnum } from 'app/core/enums/payor.enum';
import { ValidateTimesHelper } from 'app/core/helpers/validate-times-helper.service';
import { TabsReservationEnum } from 'app/core/enums/tabs-reservation.enum';
import { EncounterTypeEnum } from 'app/core/enums/encounter-type.enum';
import { IOpenReport, IParametersOpenReport } from 'app/core/interfaces/IGenericReport.interface';
import { GenericReportingService } from 'app/core/services/genericReporting.service';
import { TenantsEnum } from '../../../../core/enums/tenants.enum';
import { EditReservationEnum } from 'app/core/enums/tabs-edit-reservation.enum';
import { ValidationsTripService } from 'app/core/helpers/validations-trip.service';
import { ReportsIdEnum } from 'app/core/enums/reportsId.enum';
import { PlanService } from 'app/core/services/plan.service';
import { filter, switchMap } from 'rxjs/operators';
import { RoleEnum } from 'app/core/enums/role.enum';
import { TripLocationType } from 'app/core/enums/trip-location.enum';
import { of } from 'rxjs/observable/of';
import { UploadsService } from '../../../A2-utils/uploads.service';
import { SignalRFacadeService } from 'app/services/signal-r-facade.service';
import { IHubConnection, ISignalRError } from 'app/core/interfaces/signal.interface';
import { isHubConnection, isSignalRError } from 'app/core/signalr-type-guards.ts/signalr-type-guards';
declare var jQuery: any;
declare const moment: any;

@Component({
  selector: 'app-edit-reservation-form',
  templateUrl: './edit-reservation-form.component.html',
  styleUrls: ['./edit-reservation-form.component.scss']
})
export class EditReservationFormComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {
  TripLocationType = TripLocationType;
  public viewReasonPU = false;
  public viewReasonDO = false;
  private signalRConnectionID: string;
  public providerstatusid = 0;
  public facilityDesc = null;
  public hasFax = false;
  public faxURL = '';
  public isEditbaleTrip = false;
  public isClientUser: boolean = JSON.parse(localStorage.getItem('currentUser')).isClient;
  public isSendToLyft = true;
  public currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
  isWebApp = JSON.parse(localStorage.getItem('isWebApp'));
  public drivername = 'No Driver Assigned';
  public editIcon = 'fa-pencil-square-o';
  public modifiers: any;
  public statusList: any;
  public cancelReasonList: any;
  public sw = true;
  public swPU = true;
  public swDO = true;
  public iscancelreason = false;
  public collapseTripLocations = false;
  public sectionEmited: any;
  public tripId: any;
  public reservationForm: FormGroup;
  public imageSignature: any;
  public addressSP: IDropoffServiceProvider;
  public reasonsDelay: IReasonDelay[];
  public disabledReasons = true;
  public model = new TripModelR();
  protected showForm = false;
  protected calltypes: ICallTypeResponse[] = [];
  protected reasonSigns: any[];
  protected payors: any[];
  public payorHasExcludeProviders = false;
  protected drivers: any[];
  protected vehicles: any[];
  protected reasonsServices: any = [];
  protected fullAddresPU: any;
  protected fullAddresDO: any;
  protected facilityPU: any;
  protected facilityDO: any;
  protected phoneMask = constant.MASK_PHONE;
  protected timeMask = constant.MASK_TIME;
  protected dateMask = constant.MASK_DATE;
  protected dateTimeMask = constant.MASK_DATE_TIME;
  public mask_time = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
  protected dropoffClear = new TripLocationModel();
  /*protected tripStatus = constant.TRIP_SATUS;*/
  protected isLoadedMiles = false;
  protected totalmilesround: number;
  protected isPossibleChangeDate = false;
  protected requiredModifier = false;
  protected payorIsAllowMRS = false;
  protected reasonTransportRequired = true;
  protected serviceproviderrequired = false;
  protected rangeHours: string[];
  private observables: Subscription[] = [];
  private timers = [];
  protected myDatePickerOptions: IMyOptions = {
    dateFormat: 'mm-dd-yyyy',
    editableDateField: false,
    height: '25px'
  };
  protected companies: ICompanyProvider[];
  protected brokers: any[];
  protected vehicleIcon: any = '';
  protected driverInfo: any[];
  public tab = 1;
  public createChangeProviderInstance = false;
  public createStatusChangeInstance = false;
  public createAssignDriverInstance = false;
  public createCompleteInstance = false;
  protected showPhone = false;
  protected vehicleCode: string;
  protected driverphone: string;
  protected providerPhone: ICompanyProvider = {} as ICompanyProvider;
  protected showMsjWclift = true;
  protected showLocationPU = false;
  protected showLocationDO = false;
  protected informationTrip: any = undefined;
  protected isEncounterHistory = false;
  public paymentReceiptUploading = false;
  public paymentReceiptSelectedFileName = '';
  public paymentReceiptUploadFile: any;
  public paymentReceiptLoading = false;
  public paymentReceiptAttachment = '';
  public paymentReceiptFrameUrl: SafeResourceUrl = null;
  public selectedReasonDescription = '';
  private connection?: string;
  private editReservationHubConnection = 'hasNewTripChanges';


  permissions = {
    viewReservation: false, // isAllowedAction('View')
    readyToGo: false, // isAllowedAction('Ready to go')
    cancelTrip: false, // isAllowedAction('Cancel Trip')
    toComplete: false, // isAllowedAction('To Complete')
    changeStatusEdit: false, // isAllowedAction('Change Status Edit')
    changeProvider: false, //  isAllowedAction('Change Provider')
    changeVehicle: false, // isAllowedAction('Change Vehicle')
    updateReservation: false, // isAllowedAction('Update')
    showProviderStatus: false, // isAllowedAction('ShowProviderStatus')
    showClaimTab: false, // isAllowedAction('Claim Tab')
    showBillingTab: false, // isAllowedAction('Billing Tab')
    showNotesTab: false, // isAllowedAction('Notes Tab')
    showHistoryTab: false, // isAllowedAction('History Tab')
    showSurveyTab: false, // isAllowedAction('Survey Tab')
    showRouteTab: false, // isAllowedAction('Route Tab')
    showDriverManifest: false, // isAllowedAction('DriverManifest')
    editCompany: false, // isAllowedAction('Edit Company')
    changeScalation: false, // isAllowedAction('Change Escalation')
    viewProviderBilling: false, // isAllowedAction('View Provider Billing')
    editNegotiatedRate: false, // isAllowedAction('Edit Negotiated Rate')
    viewClientBilling: false, // isAllowedAction('View Client Billing')
    editLoadedMiles: false, // isAllowedAction('Edit Loaded Miles')
    deleteNotes: false, // isAllowedAction('Delete Note')
    signatureRequired: false, // Signature Required in complete trip.
    driverManifestRequired: false, // driver manifest in complete trip
    editNotes: false, // edit notes in edit reservation
    editDepot: false, // edit notes in edit reservation
    reasonForDelay: false, // Reason for delay in pickut
    sendToLyft: false, // para enviar a lyft
    sendToUber: false, // para enviar a uber
    encounterHistory: false,
    showDriverPhone: false,
    showProviderPhone: false,
    downloadBillingReport: false,
    setPlanTypeAndRegion: false,
    sendTracking: false,
    paymentReceiptUpload: false
  };


  protected MASK_DECIMAL = constant.MASK_DECIMAL;
  label_contracted_negotiated = 'Contracted Rate';
  dhpAuth: string;

  _rules: any;
  loadingModule = true;
  onChangeRules = false;
  disabledPickup: boolean;
  disabledDrop: boolean;
  disbledSaveByPhone: boolean;

  inputsFrom = inputsFrom;

  // Actions Rules
  onApplyingRules: boolean;

  // End Action Rules

  @Input() viewBtnOpenRidersCreate = false;
  @Input() isOpenAppRidersCreate = false;
  @Input() reservationID: any = 0;
  @Input() isStandingOrder = false;
  @Input() reservationModule = false;
  @Input() standingOrderId: number;
  @Input() standingOrderstartDate: any;
  @Input() standingOrderDate: any;
  @Input() editOnStandingOrder = false;
  @Input() controlingEditBtn: boolean;
  @Input() isUnprocessedClaims: boolean;

  @Output() tripLockStatus = new EventEmitter < any > ();
  @Output() reloadTrips = new EventEmitter < any > ();
  @Output() reloadGrids = new EventEmitter < any > ();
  @Output() updatedTrip = new EventEmitter < any > ();
  @Output() isTripEditing = new EventEmitter < any > ();
  @Output() dataTripEmmit = new EventEmitter < any > ();
  @Output() isValidForm = new EventEmitter <any> ();
  @Output() emitterOpenAppRidersCreate = new EventEmitter < any > ();
  @Output() updateSo? = new EventEmitter<boolean>();
  @Output() validateTime = new EventEmitter<boolean>();

  @ViewChild(GoogleMapsComponent) map: GoogleMapsComponent;
  @ViewChild('alertDate') private datePastWarning: T2CardComponent;
  // @ViewChild('alertHour') private hourAlert: T2CardComponent;
  @ViewChild('alertMileage') private mileageAlert: T2CardComponent;
  @ViewChild('alertLargeMileage') private mileageExecedAlert: T2CardComponent;
  @ViewChild('changeProviderPopup') private changeProviderPopup: T2CardComponent;
  @ViewChild('changeStatusPopup') protected changeStatusPopup: T2CardComponent;
  @ViewChild('assignDriverVehiclePopup') private assignDriverVehiclePopover: T2CardComponent;
  @ViewChild('completeStatusPopup') private completeStatusPopup: T2CardComponent;
  @ViewChild('editReservationFormContainer') private editReservationFormContainer: ElementRef;
  @ViewChild('pickupDateCard') private pickupDateCard: T2CardComponent;
  @ViewChild('iframeReport') private iframeReport: ElementRef;
  @ViewChild('reservationnotes') private notesComponents: ReservationNoteListComponent;
  @ViewChild('addressServiceProv') private  addressServiceProv: T2CardComponent;
  @ViewChild('providerBillingModal') private  providerBillingModal: T2CardComponent;
  @ViewChild('clientBillingModal') private  clientBillingModal: T2CardComponent;
  @ViewChild('paymentReceiptModal') private  paymentReceiptModal: T2CardComponent;
  @ViewChild('changeTimeModal') private  changeTimeModal: T2CardComponent;
  @ViewChild('driverManifest') public driverManifest: T2CardComponent;
  @ViewChild('signatureModal') public signatureModal: T2CardComponent;

  isSafety: boolean;
  isDHP = JSON.parse(localStorage.getItem('isDHP'));
  private showNaturePriority = false;
  natureDate = [];
  priorityDate  = [];
  NatureIdModel: number;
  PriorityIdModel: number;
  protected animalservice = false;
  public selectDepots: DepotModel[] = [];
  nextReload = true;
  reasonsTransportInvalid: any[] = [];
  viewAlert = false;
  numberOfLegs = 1;
  private isModalOpen = false;
  private originalReasonId: number | null = null;

  protected standingOrderTrip: any;
  protected currentStandingOrder: any;

  get triplatereasonCtrl(): AbstractControl {
    return this.reservationForm.get('triplatereasonid');
  }

  get getCurrentLeg(): AbstractControl {
    return this.reservationForm.get('leg');
  }

  get validateComboBox(): boolean {
    return (this.triplatereasonCtrl.value === '' || this.triplatereasonCtrl.value === null);
  }


  editReservationEnum = {
    Reservation: EditReservationEnum.Reservation,
    Billing: EditReservationEnum.Billing,
    Notes: EditReservationEnum.Notes,
    History: EditReservationEnum.History,
    Survey: EditReservationEnum.Survey,
    Route: EditReservationEnum.Route,
    Claims: EditReservationEnum.Claims,
    EncounterHistory: EditReservationEnum.EncounterHistory
  };

  constructor(
    private sanitizer: DomSanitizer,
    protected service: ReservationService,
    private _depotService: DepotService,
    private fb: FormBuilder,
    protected companyService: ProvidersService,
    protected calltypeService: CallTypesService,
    protected payorService: PayorsService,
    protected onDemandDriverService: OnDemandDriversService,
    protected driverService: DriversService,
    protected vehicleService: VehiclesService,
    protected newReservationService: ReservationService,
    protected riderService: RiderService,
    protected brokerService: CompaniesService,
    protected signalRlisten: SignalRFacadeService,
    protected catchErrors: CatchingErrorsService,
    protected Inject: Injector,
    protected loading: T2LoadingService,
    protected autoSchedulerService: AutoSchedulerService,
    private _reasonDelayService: ReasonsDelayService,
    private ProvidersBillingService: ProvidersBillingService,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
    private genericReportingService: GenericReportingService,
    private ValidationsTripService: ValidationsTripService,
    private planService: PlanService,
    private uploadService: UploadsService
  ) {
    super('app-edit-reservation-form', Inject);
    this.observables.push(
      this.$actions.subscribe(data => {
        this.checkPermissions();
      }));

    this.createForm();
    this.loading.show();
    this.addressSP = <IDropoffServiceProvider>{};
    this.getReasosnsDelay();
    this.getStandingOrderTrips();
  }

  initSignalR() {
    this.observables.push(
      this.signalRlisten.watchConnection$().subscribe({
        next: (res: IHubConnection | ISignalRError | null) => {
          if (!res) {
            return;
          }
          if (isSignalRError(res)) {
            this.sweetAlertHelper.captureException(res.message);
            return;
          }
          if (isHubConnection(res)) {
            this.connection = res.id;
            this.setupEditReservationHubSubscription();
          }
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        }
      })
    );
  }

  private setupEditReservationHubSubscription() {
    const tripId = this.queryTripId || this.reservationForm.get('tripid').value;
    if (!tripId) {
      return;
    }
    this.observables.push(
      this.signalRlisten
        .registerHubConnection(constant.URL_HUB_EDIT_RESERVATION, tripId)
        .subscribe({
          next: () => {
            this.signalRlisten.subscribeTo(
              this.editReservationHubConnection,
              (data: string) => {
                if (!data) {
                  return;
                }
                let parsedData: any;
                try {
                  parsedData = JSON.parse(data);
                } catch (error) {
                  return;
                }
                if (!parsedData) {
                  return;
                }
                const newTrip = parsedData;
                if (tripId === newTrip.tripid) {
                  this.nextReload = false;
                  this.toastrAlertHelper.info(
                    'The trip has been updated, the form will be reload.',
                  );
                  this.updateModelWithSignalR(newTrip);
                  this.reloadGrids.emit(false);
                }
              },
            );
          },
          error: (error) => {
            this.sweetAlertHelper.captureException(error);
          },
        })
      );
    }

  checkPermissions() {
    const per = this.permissions;
    per.viewReservation = this.isAllowedAction('View');
    per.readyToGo = this.isAllowedAction('Ready to go');
    per.cancelTrip  = this.isAllowedAction('Cancel Trip');
    per.toComplete  = this.isAllowedAction('To Complete');
    per.changeStatusEdit  = this.isAllowedAction('Change Status Edit');
    per.changeProvider  = this.isAllowedAction('Change Provider');
    per.changeVehicle = this.isAllowedAction('Change Vehicle');
    per.updateReservation = this.isAllowedAction('Update');
    per.showProviderStatus  = this.isAllowedAction('ShowProviderStatus');
    per.showClaimTab  = this.isAllowedAction('Claim Tab');
    per.showBillingTab  = this.isAllowedAction('Billing Tab');
    per.showNotesTab = this.isAllowedAction('Notes Tab');
    per.showHistoryTab = this.isAllowedAction('History Tab');
    per.showSurveyTab = this.isAllowedAction('Survey Tab');
    per.showRouteTab = this.isAllowedAction('Route Tab');
    per.showDriverManifest = this.isAllowedAction('DriverManifest');
    per.editCompany = this.isAllowedAction('Edit Company');
    per.changeScalation = this.isAllowedAction('Change Escalation');
    per.viewProviderBilling = this.isAllowedAction('View Provider Billing');
    per.editNegotiatedRate = this.isAllowedAction('Edit Negotiated Rate');
    per.viewClientBilling = this.isAllowedAction('View Client Billing');
    per.editLoadedMiles = this.isAllowedAction('Edit Loaded Miles');
    per.deleteNotes = this.isAllowedAction('Delete Note');
    per.signatureRequired = this.isAllowedAction('Signature Required');
    per.driverManifestRequired = this.isAllowedAction('Driver Manifest required');
    per.editNotes = this.isAllowedAction('Edit Notes');
    per.editDepot = this.isAllowedAction('Show Depot');
    per.reasonForDelay = this.isAllowedAction('Reason for delay');
    per.sendToLyft = this.isAllowedAction('Send To Lyft');
    per.sendToUber = this.isAllowedAction('SendToUber');
    per.encounterHistory = this.isAllowedAction('ViewEncounterHistory');
    per.showDriverPhone = this.isAllowedAction('ShowDriverPhoneClientUser');
    per.showProviderPhone = this.isAllowedAction('ShowProviderPhoneClientUser');
    per.downloadBillingReport = this.isAllowedAction('DownloadBillingReport');
    per.setPlanTypeAndRegion = this.isAllowedAction('SetPlanTypeAndRegion');
    per.sendTracking = this.isAllowedAction('Send Tracking');
    per.paymentReceiptUpload = this.isAllowedAction('PaymentReceiptUpload');
  }
  updateModelWithSignalR(data) {
    if (data.triplocationpickup && data.triplocationdropoff) {
      this.model = data;
      this.model.activationtime = data.activationtime;
      this.model.actualdropoff = data.actualdropoff;
      this.model.actualpickup = data.actualpickup;
      this.model.pickup = data.pickup;
      this.model.tripcancelreasonid = data.tripcancelreasonid;
      this.model.tripstatusid = data.tripstatusid;
      this.reloadForm(data);
    }
  }
  private getServiceReservation(tripId: number) {
    if (this.isStandingOrder) {
      return of(null);
    }
    return this.service.getTripById(tripId);
  }
  private getServiceTripStatus() {
    return this.service.getTripStatus();
  }
  private getServiceCompanies() {
    return this.companyService.getCompanies('all');
  }
  private getServiceBrokers() {
    return this.brokerService.getAllBrokers();
  }
  private getServiceModifier() {
    return this.service.getTripModifiers();
  }
  private getServiceSignReason() {
    return this.service.getSignReason(true);
  }

  private getSelectDepots() {
    this._depotService.get(this.model.companyid).subscribe((depots) => {
      this.selectDepots = depots;
    });
  }
  initialLoader() {
    this.eventEmiterSelectedTab(4, 'Edit Rider');
    const getReservation$ = this.getServiceReservation(this.queryTripId);
    const getTripStatus$ = this.getServiceTripStatus();
    const getCompanies$ = this.getServiceCompanies();
    const getBrokers$  = this.getServiceBrokers();
    const getModifier$ = this.getServiceModifier();
    const getSignReason$ = this.getServiceSignReason();
    const arrayServices = [getReservation$, getTripStatus$, getCompanies$, getBrokers$, getModifier$, getSignReason$];
    this.observables.push(
      Observable
        .forkJoin(arrayServices).subscribe(result => {

        if (
          !result[0] &&
          !this.isStandingOrder &&
          !this.validateTripIdForNewLeg
        ) {
          this.loading.hiden();
          this.toastrAlertHelper.error(
            'You do not have permission to view this trip information.',
          );
          return;
        }

        if (this.isStandingOrder || this.validateTripIdForNewLeg) {
          this.reloadForm(this.reservationID);
        } else {
          this.reloadForm(result[0]);
        }

        this.informationTrip  = result[0];
        this.statusList       = result[1] ;
        this.companies        = result[2] ;
        this.brokers          = result[3] ;
        this.modifiers        = result[4] ;
        this.reasonSigns      = result[5] ;
        this.initReasonForDelay();
      }));
  }

  ngOnInit() {
    this.initSignalR();
    this.isSafety = JSON.parse(localStorage.getItem('isSafety')) === true;
    this.rangeHours = this.createRangeHours(0, 6, 30);
    this.initialLoader();
    this.subscribeObservables();
    this.suscribeFormChanges();
  }

  initReasonForDelay(): void {
    if (this.permissions.reasonForDelay && this.triplatereasonCtrl.value && this.triplatereasonCtrl.value !== '') {
      const puValue = this.reservationForm.get('pickup').value;
      const addedOnValue = this.reservationForm.get('addedon').value;
      const dosValue = this.reservationForm.get('dateofservice').value;
      const appointmentValue = this.reservationForm.get('appointment').value;
      const actualPU = this.reservationForm.get('actualpickup').value;
      const actualDO = this.reservationForm.get('actualdropoff').value;

      this.viewReasonPU = ValidateTimesHelper
      .validPickup({
        time: actualPU, pickup: puValue, addedon: addedOnValue,
        dateofservice: dosValue, currentLeg: this.getCurrentLeg.value
      });

      this.viewReasonDO = ValidateTimesHelper
      .validDropOff({
        time: actualDO, pickup: puValue, addedon: addedOnValue, dateofservice: dosValue,
        currentLeg: this.getCurrentLeg.value, appointmentCurrent: appointmentValue
      });
    }
  }

  suscribeFormChanges() {
    this.observables.push(
      this.reservationForm.get('tripreasontransportid').valueChanges.subscribe((value) => {
        if (value) {
          this.newReservationService.tripReasonTransport.next(value);
          if (this.reasonsTransportInvalid && this.reasonsTransportInvalid.length) {
            const selectExists = this.reasonsServices.find((reason) => Number(reason.tripreasontransportid) === Number(value));
            if (selectExists) {
              this.reasonsTransportInvalid = [];
            }
          }
        }
      }),
      this.reservationForm.get('companyid').valueChanges.subscribe({
        next: (value) => {
          if (value) {
            this.newReservationService.companySelectedSubject.next(value);
          }
        }
      })
    );
  }

  subscribeObservables() {
    this.observables.push(
      this.newReservationService.saveEditTime$.subscribe((resp: boolean) => {
        this.saveChangeTime(resp);
      })
    );

    this.observables.push(
      this.service.reloadReservation$.subscribe((reload: boolean) => {
        if (reload) {
          this.reloadTrips.emit(this.model.tripid);
        }
      })
    );

    this.observables.push(
      this.service.reloadTotalAmount$.subscribe((reload: boolean) => {
        if (reload) {
          this.getTotalAmount();
        }
      })
    );

    this.observables.push(
      this.newReservationService.reloadTrips$.subscribe((res) => {
        if (res && this.isStandingOrder) {
          this.swPU = true;
          this.swDO = true;
        }
      })
    );

    this.observables.push(
      this.newReservationService.updateEncounterHistory$
        .pipe(
          filter((tripId) => !!tripId),
          switchMap((tripId: number) => this.getServiceReservation(tripId))
        )
        .subscribe({
          next: (trip) => {
            if (trip) {
              this.service.setEncounterData({
                tripId: trip.tripid,
                tripPaymentDate:
                  trip && trip.trippaymentsdateformatted
                    ? trip.trippaymentsdateformatted
                    : '',
                encounterStatus:
                  trip && trip.encounterstatus
                    ? trip.encounterstatus.description
                    : '',
                planType: trip.reservation.plantype,
                region: trip.reservation.region,
                showButton: this.permissions.setPlanTypeAndRegion,
              });
            }
          },
          error: (err) => {
            this.sweetAlertHelper.captureException(err);
          },
        })
    );
    if (!this.isStandingOrder) {
      this.observables.push(
        this.planService.changeReloadReservation
          .finally(() => this.planService.notifyReloadReservation(false))
          .subscribe({
            next: (res) => {
              const tripId = this.reservationForm.get('tripid').value;
              if (res && tripId) {
                this.updateTrips(tripId);
              }
            }, error: (err) => {
              this.sweetAlertHelper.captureException(err);
            }
          })
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if ( changes['editOnStandingOrder'] && this.editOnStandingOrder ) {
      this.onClickEditReservationBtn();
    }
    if (changes['controlingEditBtn'] && this.controlingEditBtn ) {
      this.reservationForm.disable();
      this.sw = true;

    }
  }

  validateFullAddress() {
    const triplocationpickup = this.reservationForm.get('triplocationpickup').value;
    const triplocationdropoff = this.reservationForm.get('triplocationdropoff').value;
    const locationPU = this.validateExistsValuesAddress(triplocationpickup.location);
    const streetaddressVal = this.validateExistsValuesAddress(triplocationpickup.streetaddress);
    const roomaptnumberVal = this.validateExistsValuesAddress(triplocationpickup.roomaptnumber);
    const cityVal = this.validateExistsValuesAddress(triplocationpickup.city);
    const stateVal = this.validateExistsValuesAddress(triplocationpickup.state);
    const zipVal = this.validateExistsValuesAddress(triplocationpickup.zip);
    const countyPU = this.validateExistsValuesAddress(triplocationpickup.county);
    const locationDO = this.validateExistsValuesAddress(triplocationdropoff.location);
    const streetaddressDO = this.validateExistsValuesAddress(triplocationdropoff.streetaddress);
    const roomaptnumberDO = this.validateExistsValuesAddress(triplocationdropoff.roomaptnumber);
    const cityDO = this.validateExistsValuesAddress(triplocationdropoff.city);
    const stateDO = this.validateExistsValuesAddress(triplocationdropoff.state);
    const zipDO = this.validateExistsValuesAddress(triplocationdropoff.zip);
    const countyDO = this.validateExistsValuesAddress(triplocationdropoff.county);
    const addresPU = [streetaddressVal, roomaptnumberVal, cityVal, stateVal, zipVal, countyPU];
    const addresPO = [streetaddressDO, roomaptnumberDO, cityDO, stateDO, zipDO, countyDO];
    this.fullAddresPU = addresPU.map(e => ' ' + e.split(','));
    this.fullAddresDO = addresPO.map(e => ' ' + e.split(','));
    this.facilityPU = locationPU;
    this.facilityDO = locationDO;
  }

  validateExistsValuesAddress(control: any) {
    return control ? control : '-';
  }

  public onTimesChanged(event, field, nativeEvent?) {
    this.onValidateInputTime();
    this.updatePickupDateFlag();
    if (this.currentUser.usertypeid === 2) {
      return;
    }
    // const validPickup = this.ValidationsTripService.validateTimePickup(this.reservationForm.value);
    // if (!validPickup) {
    //   this.reservationForm.patchValue({
    //     appointment: null,
    //     pickup: null,
    //   });
    //   return;
    // }
    if (!event.includes('_')) {
      const dos = this.reservationForm.get('dateofservice').value;
      const actualDate = moment().format('YYYY-MM-DD');
      const dosIsBefore = moment(dos).isBefore(actualDate);

      if (!this.editOnStandingOrder) {
        if (dosIsBefore && !this.sw) {
          this.sweetAlertHelper.createCustomAlert({
            type: 'warning',
            text: 'You are modifying an hour in the past.'
          });
        }
      }

      if (field === 'appointment') {
        if (nativeEvent) {
          if (nativeEvent.key !== 'Tab') {
            this.calculatePickup();
          }
        }
      }
    }
  }
  public clearTimes() {
    this.reservationForm.patchValue({
      appointment: null,
      pickup: null
    });
    this.reservationForm.get('pickup').updateValueAndValidity();
    this.reservationForm.get('appointment').updateValueAndValidity();
    this.updatePickupDateFlag();
  }
  public clearManualMiles() {
    this.reservationForm.patchValue({
      manualmiles: 0
    });
    this.reservationForm.get('manualmiles').updateValueAndValidity();
    this.mileageAlert.close();
  }
  public clearDropoff() {
    this.reservationForm.get('triplocationdropoff').setValue(this.dropoffClear);
    this.reservationForm.patchValue({
      loadedmiles: 0,
      manualmiles: 0
    });
    this.onChangeMiles();
    this.mileageExecedAlert.close();
  }
  public onChangeTripDate(event ? ) {
    if (event.key !== 'Tab') {
      const dos = this.reservationForm.get('dateofservice').value;
      const statusid = this.reservationForm.get('tripstatusid').value;
      if (!dos.includes('_') && statusid === 1) {
        this.clearTimes();
        if (new Date(dos + 'T00:00:00') < new Date(new Date().setHours(0, 0,
          0, 0))) {
          this.datePastWarning.open();
        }
        this.validShowReason(this.reservationForm.get('payorid').value);
      }
    }
  }
  public clearDOS() {
    this.reservationForm.get('dateofservice').setValue(null);
    this.reservationForm.get('dateofservice').updateValueAndValidity();
  }
  private calculatePickup() {
    const aptime = this.reservationForm.get('appointment').value;
    const totalM = this.reservationForm.get('totalmiles').value;
    const calltypeid = this.reservationForm.get('calltypeid').value;
    if (aptime && totalM && calltypeid) {
      this.observables.push(
        this.service.getEstimatedPickup(calltypeid, totalM, aptime).subscribe(
          data => {
            if (data && this.reservationForm.get('pickup').value !== data.slice(0, 5)) {
              this.sweetAlertHelper.createCustomAlert({
                type: 'warning',
                text: 'Want to modify Sched. PU',
                showCancelButton: true,
                cancelButtonText: 'No',
                allowOutsideClick: false,
                allowEnterKey: false
              }).then(
                resul => {
                  if (resul.value) {
                    this.reservationForm.patchValue({
                      pickup: data.slice(0, 5)
                    });
                    this.onTimesChanged(data, 'pickup');
                  }
                }
              );
            }else {
              this.reservationForm.patchValue({
                pickup: data.slice(0, 5)
              });
              this.onTimesChanged(data, 'pickup');
            }
          }
        ));
    }
  }

  private updatePickupDateFlag(): void {
    const formValue = this.reservationForm.getRawValue();
    if (this.isStandingOrder) {
      this.model.pickupdate = this.ValidationsTripService.isPreviousDayPickup(formValue) ? 'overnight' : null;
    } else {
      this.model.pickupdate = this.ValidationsTripService.getPickupDate(formValue);
      if (!this.model.pickupdate && this.pickupDateCard) {
        this.pickupDateCard.close();
      }
    }
  }

  private onChangeMiles() {
    this.roundMiles();
    this.getTotalAmount();
  }
  protected onChangeLoadedMiles() {
    if (!this.reservationForm.get('isloadedmiles').value) {
      this.reservationForm.get('manualmiles').setValidators(Validators.required);
      this.roundMiles();
    } else {
      this.reservationForm.get('manualmiles').clearValidators();
      const loadedMiles = this.reservationForm.get('loadedmiles').value;
      this.reservationForm.patchValue({totalmiles: this.round(loadedMiles)});
    }
    this.reservationForm.updateValueAndValidity();
    this.getTotalAmount();
  }
  private roundMiles() {
    const totalmiles = this.reservationForm.get('manualmiles').value;
    this.totalmilesround = this.round(totalmiles);
  }
  public round(miles): number {
    return miles !== null ? (miles % 1 > 0.09 ? Math.floor(miles) + 1 : Math.floor(miles)) : 0;
  }
  private onChangeCalltype() {
    const calltypeid = this.reservationForm.get('calltypeid').value;
    const companyid = this.reservationForm.get('companyid').value;

    /*if (calltypeid !== 1 && companyid === 20) {
      this.reservationForm.patchValue({
        calltypeid: 1
      });
      this.toastrAlertHelper.warning('trip2 only accept ambulatory calltype');
      return;
    }*/
  }
  private calculateEstimatedTime(event ? ) {
    this.validateFullAddress();
    if (!this.sw) {
      if (event !== undefined) {
        this.timers.push(
          setTimeout(() => {
            this.calculateEstimatedTime();
          }, 1000)
        );
        return;
      }
      const pickup = {
        latitude: this.reservationForm.get('triplocationpickup').value.latitude,
        longitude: this.reservationForm.get('triplocationpickup').value.longitude
      };
      const dropoff = {
        latitude: this.reservationForm.get('triplocationdropoff').value.latitude,
        longitude: this.reservationForm.get('triplocationdropoff').value.longitude
      };
      // Add observable tu array observables
      this.observables.push(
        this.service.getTotalMiles(pickup.latitude, pickup.longitude,
          dropoff.latitude, dropoff.longitude).subscribe(
          data => this.processTotalMiles(data)
        ));
    }
  }
  private processTotalMiles(data) {
    if (data.rows[0].elements[0].duration !== undefined &&
    data, data.rows[0].elements[0].distance !== undefined) {
      const timeSeconds = data.rows[0].elements[0].duration.value / 60;
      const distance = ((data.rows[0].elements[0].distance.value) * 0.000621371)
        .toFixed(2);
      let totalMilesValue = 0;
      if (this.reservationForm.get('isloadedmiles').value) {
        totalMilesValue = this.round(distance);
      } else {
        totalMilesValue = this.reservationForm.get('manualmiles').value;
      }
      this.reservationForm.patchValue({
        estimatedtime: Math.round(timeSeconds),
        loadedmiles: parseFloat(distance),
        totalmiles: totalMilesValue
      });
      if (totalMilesValue >= 50) {
        this.viewAlert = true;
      }
      this.reservationForm.updateValueAndValidity();
      this.model.totalmiles = totalMilesValue;
      this.model.loadedmiles = parseFloat(distance);
      this.onChangeMiles();
      this.calculatePickup();
      this.getTotalAmount();
      this.roundMiles();
    }
  }

  private getTotalAmount() {
    const payorid = this.reservationForm.get('payorid').value;
    const calltypeid = this.reservationForm.get('calltypeid').value;
    const totalmiles = this.reservationForm.get('totalmiles').value;
    const dos = this.reservationForm.get('dateofservice').value;
    const providerid = this.reservationForm.get('companyid').value;
    const lyftamount = this.reservationForm.get('totalamountlyft').value;
    const triplocationpickup = this.reservationForm.get('triplocationpickup').value;
    const countyPU = triplocationpickup.county;
    const riderId = this.reservationForm.get('riderid').value;
    if (providerid === 27 && this.payorIsAllowMRS) {
      // Add observable to array observers
      this.observables.push(
        this.service.getAllowMRSAmount(payorid, lyftamount, providerid).subscribe(
          data => this.reservationForm.patchValue({
            totalamount: data
          })
        ));
    } else {
      if (calltypeid && totalmiles !== null) {
        // Add observable to array observers
        this.observables.push(
          this.service.getTotalAmmount(riderId, payorid, calltypeid, totalmiles, dos, countyPU).subscribe(
            data => this.reservationForm.patchValue({
              totalamount: data
            })
          ));
      }
    }
  }
  loadRulesForPayor() {
    this.onChangeRules = true;
    this.onApplyingRules = true;
    this.loading.show();
    if (this.reservationForm.get('payorid') !== null && this.reservationForm.get('payorid') !== undefined ) {
      this.getActionsForPayor(this.reservationForm.get('payorid').value);
    }
  }
  protected onChangePayor() {
    const payorOld = this.payors.find(
      (f) => f.payorid === this.reservationForm.get('payorid').value
    );
    if (!payorOld.payor.isactive && !this.validateAdminUser) {
      this.sweetAlertHelper.customAlertPayorInactive(payorOld.payor);
      this.reservationForm.get('payorid').setValue(null);
    } else {
      this.loadRulesForPayor();
      this.getPayorData();
      this.getPayorCallTypes();
      this.getTotalAmount();
      this.getTripReasons(this.reservationForm.get('payorid').value);
    }
  }
  private getPayorData() {
    const pid = this.reservationForm.get('payorid').value;
    if (pid) {
      // Add observable to array observers
      this.observables.push(
        this.payorService.getPayorsByPayorId(pid).subscribe(
          data => {
            if (data && !data.isactive && !this.validateAdminUser) {
              this.sweetAlertHelper.customAlertPayorInactive(data);
            }
            this.reservationForm.patchValue({
              _isauthrequired: data.ismodifierrequired,
              _isreasonfortransportrequired: data.isreasonfortransportrequired,
              _isserviceproviderrequired: data.isserviceproviderrequired
            });
            this.requiredModifier = data.ismodifierrequired;
            this.reasonTransportRequired = data.isreasonfortransportrequired;
            this.serviceproviderrequired = data.isserviceproviderrequired;
            this.setServiceProviderValidators();
            this.payorIsAllowMRS = data.allowmrscost;
            this.payorHasExcludeProviders = data.hasexcludeproviders;
          }
        ));
    }
  }

  private setServiceProviderValidators() {
    const control = this.reservationForm.get('serviceprovidername');
    if (this.serviceproviderrequired) {
      control.setValidators(Validators.required);
    } else {
      control.clearValidators();
    }
    control.updateValueAndValidity();
  }

  private isWillCall() {
    const iswillcall = this.reservationForm.get('iswillcall').value;
    if (iswillcall) {
      this.reservationForm.get('isactivationnow').setValue(false);
      this.onChangePUNow(false);
    }
  }


  private getPayors() {
    if (this.model.riderid) {
      this.observables.push(
        this.riderService.getPayorByRider(this.model.riderid, this.model.dateofserviceformatted).subscribe(
          data => {
            this.payors = data;
            this.getTripReasons(this.model.payorid);
            if (this.payors) {
              this.permissionEncounterHistory();
            }
          }
        ));
      /*this.getTripReasons(this.model.payorid);*/
    }
  }
  private getPayorCallTypes() {
    const payorid = this.reservationForm.get('payorid').value;
    if (payorid) {
      this.showNaturePriority = false;
      this.observables.push(
        this.payorService.getPayorCallTypes(payorid).subscribe(
          (data: ICallTypeResponse[]) => {
            const calltype: ICallTypeResponse = this.getCallTypeSelected();
            this.calltypes = assignNewArray(data);
            if (this.reservationForm.get('calltypeid').value) {
              this.validCallTypeOfPayor(calltype);
            }
          }
        ));
    }
  }
  private onChangeStatus() {
    const tripstatusid = this.reservationForm.get('tripstatusid').value;
    this.isPossibleChangeDate = tripstatusid === 1;
  }
  private loadCancelReason() {
    this.observables.push(
      this.service.getCancelReason().subscribe(
        data => {
          this.cancelReasonList = data;
        }
      ));
  }

  reloadReasonsByTripId(event: any) {
    this.getTripReasons(event, true, true);
  }

  private getTripReasons(payorId: number, edit?: boolean, billingSchedule?: boolean) {
    const payorValidate = [PayorEnum.SimplyMMA, PayorEnum.SimplyMCR, PayorEnum.FloridaCommunityCare, PayorEnum.FloridaCompleteCare];
    const riderPayorID = payorValidate.includes(payorId) ? this.payors.find((f: IRiderPayor) => f.payorid === payorId).riderpayorid : '';
    const dateOfService = payorValidate.includes(payorId) ? this.reservationForm.get('dateofservice').value : '';
    const sOrdenStartDate = payorValidate.includes(payorId) && this.isStandingOrder ? this.standingOrderstartDate : '';
    const serviceDate = payorValidate.includes(payorId) && this.standingOrderstartDate ? sOrdenStartDate : dateOfService;
    this.observables.push(
      this.service.getPayorReasonForTransport(payorId, riderPayorID, serviceDate, billingSchedule).subscribe(
        (resp: any) => {
          this.reasonsServices = resp;
          if (this.model && this.model.tripreasontransport) {
            const reasonId = this.model.tripreasontransport.tripreasontransportid;
            const validReasons = this.reasonsServices.find((reason) => Number(reason.tripreasontransportid) === Number(reasonId));
            const invalidReasons = this.reasonsTransportInvalid.find((reason) => Number(reason.tripreasontransportid) === Number(reasonId));
            if (!validReasons && !invalidReasons) {
              this.reasonsTransportInvalid.push(this.model.tripreasontransport);
            }
          }
        },
        error => {
          if (edit) {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Error',
              text: error.message ? error.message : 'No plan found in riders profile for this Payor and Date of service',
              type: 'error',
            });
          }
        }
      ));
  }

  private createForm() {
    let dobRider = '';
    let policyRider = '';
    if (this.model) {
      if (this.model.rider) {
        if (this.model.rider.dob) {
          dobRider = this.model.rider.dob;
        }
        if (this.model.rider.policy) {
          policyRider = this.model.rider.policy;
        }
      }
    }
    this.reservationForm = this.fb.group({
      _policy: '' ,
      _isToday: '',
      _birthdaterider: '',
      _isauthrequired: false,
      _isreasonfortransportrequired: false,
      _providerstatusid: '',
      _roleid: '',
      usertype: '',
      scheduleddropofftime: '',
      tripid: '',
      dateofservice: '',
      consecutive: 0,
      tripstatusid: 0,
      calltypeid: 0,
      leg: '',
      companions: '',
      callreceived: '',
      addedon: '',
      caller: '',
      callerphone: '',
      payorauthorization: '',
      rescuenetnumber: null,
      payorid: '',
      appointment: '',
      pickup: '',
      returntime: '',
      reservationid: 0,
      notetrip: '',
      notepickup: '',
      notedropoff: '',
      riderid: '',
      companyid: '',
      brokerid: '',
      iswillcall: '',
      isreturntrip: false,
      vehicleid: null,
      driverid: null,
      tripconfirmed: null,
      estimatedtime: '',
      activationtime: '',
      noshowtime: '',
      actualdropoff: '',
      waitingtime: '',
      actualpickup: '',
      triplocationpickup: '',
      triplocationdropoff: '',
      tripreasontransportid: null,
      tripcancelreasonid: null,
      totalmiles: 0,
      loadedmiles: 0,
      manualmiles: null,
      totalamount: null,
      isnegotiatedrate: false,
      totalamountlyft: '',
      isloadedmiles: '',
      tripreasonsignid: 0,
      signaturephoto: '',
      modifiedon: '',
      isactivationnow: '',
      facilityid: '',
      facilitydesc: '',
      provideramount: '',
      faxrequestid: '',
      escalation: '',
      wclift: '',
      animalservice: '',
      serviceproviderid: null,
      serviceprovidername: '',
      depotid: null,
      triplatereasonid: '',
      googleordrguid: '',
      hasreturn: null,
      authorizationstatusdesc: null
    });
  }
  verifiqueFormRules () {
    try {
      if (this.loadingModule) {
        this.loadingModule = false;
        this.loading.hiden();
      }

      // The loading shown by loadRulesForPayor is already hidden by getActionsForPayor's finally.
      // Hiding it here again would close any other active loading (e.g. the Save in submitForm).
      this.onChangeRules = false;
      this.applyRules(this.reservationForm, 'Update');
      this.onApplyingRules = false;
    } catch (error) {
    }
  }
  driverAndVehicleAssigned() {
    if (this.model.driver) {
      this.drivername = this.model.driver.fullname;
      this.driverphone  = this.model.driver.phone;
    } else {
      this.drivername = 'Unassigned';
      this.driverphone  = '';
    }
    if (this.model.vehicle) {
      this.vehicleCode = this.model.vehicle.code;
    } else {
      this.vehicleCode = 'Unassigned';
    }

    if (this.isStandingOrder) {
      this.setVehicleAndDriverSo(this.model.vehicleid, this.model.driverid);
    }
  }
  setVehicleAndDriverSo(vehicleId, driverId) {
    if (vehicleId) {
      this.observables.push(
        this.service.getVehicleById(vehicleId).subscribe(res => {
          this.vehicleCode = res.code;
          if (!this.drivername) {
            if (res.driver) {
              this.drivername = res.driver.fullname;
              this.driverphone = res.driver.phone;
            } else {
              this.drivername = 'Unassigned';
              this.driverphone  = '';
            }
          }
        }));
    }else { this.vehicleCode = 'Unassigned'; }
    if (driverId) {
      this.observables.push(
        this.service.getDriversMCT(driverId).subscribe(res => {
          this.drivername = res.fullname;
          this.driverphone = res.phone;
        }));
    }else {
      this.drivername = 'Unassigned';
      this.driverphone  = '';
    }
  }
  private configureView() {
    this.reservationForm.disable();
    this.onChangeStatus();
    this.getPayorCallTypes();
    this.onStatusSelected(this.reservationForm.value.tripstatusid);
    this.getPayorData();
    this.verifyLoadedMiles();
  }
  private enableContractRate() {
    if (this.reservationForm.get('companyid').value === 27) {
      this.reservationForm.patchValue({
        isnegotiatedrate: true
      });
      this.reservationForm.updateValueAndValidity();
    }
  }
  private verifyLoadedMiles() {
    const loadedmiles = this.reservationForm.get('loadedmiles').value;
    if (loadedmiles === null) {
      this.calculateEstimatedTime();
    }
  }
  private onChangePUNow(event) {
    if (event) {
      this.observables.push(
        this.service.getTimeNow().subscribe(
          data => {
            const serverDate = new Date(data);
            const hour = serverDate.getHours();
            const minutes = serverDate.getMinutes();
            this.reservationForm.patchValue({
              pickup: `${(hour < 10 ? '0' : '') + hour}:${(minutes < 10 ? '0' : '') + minutes}`,
              appointment: null
            });
          }
        ));
    }
    this.onPickupNow();
  }
  private onPickupNow() {
    if (this.reservationForm.value.isactivationnow) {
      this.reservationForm.get('iswillcall').setValue(false);
      this.isWillCall();
    }
  }
  protected clearDriver() {
    this.reservationForm.patchValue({
      'driverid': null,
      'vehicleid': null
    });
  }
  protected onClickEditReservationBtn() {
    this.newReservationService.setReadOnly(this.sw);
    const payor = this.payors.find(
      (f) => f.payorid === this.reservationForm.get('payorid').value
    );
    if (payor && !this.sw && !payor.payor.isactive && !this.validateAdminUser) {
      this.sweetAlertHelper.customAlertPayorInactive(payor.payor);
      return;
    }

    if (this.reservationForm.get('totalamountlyft').value == null || this.reservationForm.get('totalamountlyft').value === 'NaN') {
      this.reservationForm.patchValue({
        totalamountlyft: 0
      });
    }
    if (!this.isStandingOrder) {
      if (this.model.tripid !== 0) {
        if (verifyServiceEnabled('reservationEnable')) {
        this.observables.push(
          this.service.postEnableTripForm(this.model.tripid).subscribe(
            data => {
              this.switchEditBtn();
              this.showMsjWclift = false;
              resetServiceEnabled('reservationEnable');
              //TODO - This is a temporal fix for the issue with the trip reason not being loaded
              /* setTimeout(() => {
                const payorid = this.reservationForm.get('payorid').value;
                this.getTripReasons(payorid, true);
              }, 4000); */
            },
            err => {
              this.sweetAlertHelper.captureException(err);
              resetServiceEnabled('reservationEnable');
            }
          ));
        }
      } else {
        this.switchEditBtn();
      }
    } else {
      this.switchEditBtn();
    }
  }

  private switchEditBtn() {
    this.sw = !this.sw;
    if (this.sw) {
      this.reservationForm.disable();
      this.submitForm(this.reservationForm.getRawValue());
    } else {
      this.reservationForm.enable();
      this.loadRulesForPayor();
      this.emitLockStatus(true);
      this.onPickupNow();
      this.isWillCall();
      this.enableContractRate();
    }
    this.isTripEditing.emit({
      tripid: this.model.tripid,
      isEditing: !this.sw
    });
  }

  private emitLockStatus(status: boolean) {
    this.tripLockStatus.emit({
      tripid: this.model.tripid,
      lock: status
    });
  }
  protected onEpandPU() {
    this.swPU = !this.swPU;
    this.pudoAnimation(this.swPU, 'PU');
  }
  private onEpandDO() {
    this.swDO = !this.swDO;
    this.pudoAnimation(this.swDO, 'DO');
  }
  private pudoAnimation(sw, PUDO) {
    this.validateFullAddress();
    const showInfoCls = PUDO === 'DO' ? '.showInfoDO' : '.showInfoPU';
    const formCls = PUDO === 'DO' ? '.formDO' : '.formPU';
    const containerCls = PUDO === 'DO' ? '.containerDO' : '.containerPU';
    if (!sw) {
      jQuery(showInfoCls).stop().animate({
        top: '-200px'
      }, 300);
      jQuery(formCls).stop().animate({
        top: '0px'
      }, 300);
      jQuery(containerCls).stop().animate({
        height: '200px'
      }, 300);
    } else {
      jQuery(showInfoCls).stop().animate({
        top: '0px'
      }, 300);
      jQuery(formCls).stop().animate({
        top: '-200px'
      }, 300);
      jQuery(containerCls).stop().animate({
        height: '85px'
      }, 300);
    }
  }
  private submitForm(data) {
    if (data.tripreasontransportid === 0) {
      this.toastrAlertHelper.error('Please select a reason for transport');
      this.switchEditBtn();
      return;
    }
    if(this.disabledReasonsDelay() && !data.triplatereasonid){
      this.toastrAlertHelper.error('Please select a Reason for delay');
      this.switchEditBtn();
      return
    }
    data.driverid = this.reservationForm.get('driverid').value;
    data.vehicleid = this.reservationForm.get('vehicleid').value;

    const pu = data.triplocationpickup;
    const dp = data.triplocationdropoff;
    data.pumanualcoordinates = !!(pu && pu.ismanualcoordinates);
    data.domanualcoordinates = !!(dp && dp.ismanualcoordinates);
    data.ismanualpuaddress = !!(pu && pu.ismanualedit);
    data.ismanualdoaddress = !!(dp && dp.ismanualedit);

    if (this.sw) {
      if (this.model.tripid !== 0) {
        if (this.showNaturePriority) {
          data.MedicalTrip = {tripid: this.model.tripid, NatureId: this.NatureIdModel, PriorityId: this.PriorityIdModel};
        }
        if (verifyServiceEnabled('reservationPutDataTrip')) {
          this.loading.show();
          this.observables.push(
            this.service.putData(data)
              .finally(() => this.loading.hiden())
              .subscribe(
              response => {
                this.updatedTrip.emit(response.data.trip);
                this.reloadForm(response.data.trip);
                if (!response.data.transaction) {
                  this.toastrAlertHelper.error('Trip has been update by other user',
                    'reload Information', {
                      toastLife: 10000
                    });
                }
                // this.getReservation(true);
                this.observables.push(this.service.putEnableTripForm(this.model.tripid).subscribe());
                this.onNotifyUpdateTrip(response);
                this.emitLockStatus(false);
                this.reloadGrids.emit(false);
                resetServiceEnabled('reservationPutDataTrip');
              },
              error => {
                this.sweetAlertHelper.captureException(error);
                this.switchEditBtn();
                resetServiceEnabled('reservationPutDataTrip');
              }
            )
          );
        }
      } else {
        this.observables.push(
          this.newReservationService.postReservation([data]).subscribe(
            response => {
              this.toastrAlertHelper.success(response.message);
              this.reloadTrips.emit(response.data[0]);
              this.reloadGrids.emit(false);

            },
            error => {
              this.toastrAlertHelper.error(this.catchErrors.catchingModelState(error), '',  {
                enableHTML: true
              } );
              this.switchEditBtn();
            }
          ));
      }
    }
  }

  private reloadForm(data) {
    this.model = data;
    this.loadFacilityInfo(data);
    this.getPayors();
    this.hasFax = (data.faxrequestid !== undefined && data.faxrequestid !== null);
    if (this.hasFax) {
      this.faxURL = data.faxrequest.attachment || '';
    }
    if (this.model) {
      let facilityDescription = '';
      if (this.model['facility'])  {
        if (this.model['facility']['description'])  {
          facilityDescription = this.model['facility']['description'];
        }
      }
      let dobRider = '';
      let policyRider = '';
      if (this.model.rider) {
        if (this.model.rider.dob) {
          dobRider = this.model.rider.dob;
        }
        if (this.model.rider.policy) {
          policyRider = this.model.rider.policy;
        }
      }
      this.reservationForm.patchValue({
        _policy: policyRider,
        _isToday: this.isToday(this.model.dateofserviceformatted),
        _birthdaterider: dobRider,
        _isauthrequired: false,
        _isreasonfortransportrequired: false,
        _isserviceproviderrequired: false,
        _providerstatusid: this.providerstatusid,
        _roleid: this.currentUser.roleid,
        scheduleddropofftime: this.model.scheduleddropofftime,
        tripid: this.model.tripid,
        dateofservice: this.model.dateofserviceformatted,
        consecutive: this.model.consecutive,
        tripstatusid: this.model.tripstatusid,
        calltypeid: this.model.calltypeid,
        leg: this.model.leg,
        companions: this.model.companions,
        callreceived: this.model.callreceived,
        addedon: this.model.addedon,
        caller: this.model.caller,
        callerphone: this.model.callerphone,
        payorauthorization: this.model.payorauthorization,
        rescuenetnumber: this.model.rescuenetnumber,
        payorid: this.model.payorid,
        appointment: this.model.appointment ? this.model.appointment.slice(0, 5) : '',
        pickup: this.model.pickup ? this.model.pickup.slice(0, 5) : '',
        returntime: this.model.returntime,
        reservationid: this.model.reservationid,
        notetrip: this.model.notetrip,
        notepickup: this.model.notepickup,
        notedropoff: this.model.notedropoff,
        riderid: this.model.riderid,
        companyid: this.model.companyid,
        brokerid: this.model.brokerid,
        iswillcall: this.model.iswillcall,
        isreturntrip: this.model.isreturntrip,
        vehicleid: this.model.vehicleid,
        driverid: this.model.driverid,
        tripconfirmed: this.model.tripconfirmed,
        estimatedtime: this.model.estimatedtime,
        activationtime: this.model.activationtimeformatted ? this.model.activationtimeformatted.slice(0, 5) : '',
        noshowtime: this.model.noshowtimeformatted ? this.model.noshowtimeformatted.slice(0, 5) : '',
        actualdropoff: this.model.actualdropoffformatted ? this.model.actualdropoffformatted.slice(0, 5) : '',
        waitingtime: this.model.waitingtimeformatted ? this.model.waitingtimeformatted.slice(0, 5) : '',
        actualpickup: this.model.actualpickupformatted ? this.model.actualpickupformatted.slice(0, 5) : '',
        triplocationpickup: this.model.triplocationpickup,
        triplocationdropoff: this.model.triplocationdropoff,
        tripreasontransportid: this.model.tripreasontransportid,
        tripcancelreasonid: this.model.tripcancelreasonid,
        totalmiles: this.model.totalmiles,
        loadedmiles: this.model.loadedmiles,
        manualmiles: this.model.manualmiles,
        totalamount: this.model.totalamount,
        isnegotiatedrate: this.model.isnegotiatedrate,
        totalamountlyft: this.model.totalamountlyft,
        isloadedmiles: this.model.isloadedmiles,
        tripreasonsignid: this.model.tripreasonsignid,
        signaturephoto: this.model.signaturephoto,
        modifiedon: this.model.modifiedon,
        isactivationnow: this.model.isactivationnow,
        facilityid: this.model.facilityid,
        facilitydesc: facilityDescription,
        provideramount: this.model.provideramount,
        faxrequestid: this.model.faxrequestid,
        escalation: this.model.escalation,
        wclift: this.model.wclift,
        serviceproviderid: this.model.serviceproviderid,
        serviceprovidername: this.model.serviceprovidername,
        animalservice: this.model.animalservice,
        depotid: this.model.depotid,
        triplatereasonid: this.model.triplatereasonid,
        googleordrguid: this.model.googleordrguid || 'MCN92-N', // TODO: Remove when backend returns the property
        hasreturn: this.model.hasreturn,
        authorizationstatusdesc: this.model.authorizationstatusdesc
      });

      this.getPayorData();

      if (this.model.pumanualcoordinates || this.model.ismanualpuaddress) {
        const tripLocationPickUp = JSON.parse(JSON.stringify(this.model.triplocationpickup));
        const puValue = Object.assign({}, tripLocationPickUp, {
          ismanualcoordinates: !!this.model.pumanualcoordinates,
          ismanualedit: !!this.model.ismanualpuaddress
        });
        this.reservationForm.get('triplocationpickup').patchValue(puValue);
      }

      if (this.model.domanualcoordinates || this.model.ismanualdoaddress) {
        const tripLocationDropOff = JSON.parse(JSON.stringify(this.model.triplocationdropoff));
        const dpValue = Object.assign({}, tripLocationDropOff, {
          ismanualcoordinates: !!this.model.domanualcoordinates,
          ismanualedit: !!this.model.ismanualdoaddress
        });
        this.reservationForm.get('triplocationdropoff').patchValue(dpValue);
      }

      if (this.model.animalservice) {
        this.animalservice = this.model.animalservice;
      }
      this.loadRulesForPayor();
      this.getSelectDepots();
    }
    this.modifierHasChanged(true);
    if (this.queryTripId !== 0) {
      this.loadCancelReason();
      this.configureView();
    } else if (this.queryTripId === 0) {
      this.getPayorData();
    }
    this.showForm = true;
    this.validateFullAddress();
    this.updatePickupDateFlag();
    if (this.isClientUser && this.reservationForm.get('tripstatusid').value !== 1) {
      this.isEditbaleTrip = false;
    } else {
      this.isEditbaleTrip = true;
    }
    this.observables.push(
      this.reservationForm.valueChanges.subscribe(
        (data) => {
          this.dataTripEmmit.emit(this.reservationForm.getRawValue());
          this.isValidForm.emit(this.reservationForm.valid);
        }
      ));
    this.driverAndVehicleAssigned();
    this.verifiqueFormRules();
    this.setMedicalTrip();
    this.getCountLegsReservation();
    this.newReservationService.riderSelectedSubject.next({ id: this.model.riderid });
    if (this.tab === 8) {
      this.sendEncounterModel();
    }
  }
  private onNotifyUpdateTrip(data) {
    if (data.success) {
      this.restoreTriplocations();
      if (data.data.transaction) {
        this.toastrAlertHelper.success(data.message);
      };
    }
  }
  protected onStatusSelected(event) {
    event === 7 ? this.iscancelreason = true : this.iscancelreason = false;
    this.timers.push(
      setTimeout(() => {
        this.isWillCall();
      }, 1000)
    );
  }
  private restoreTriplocations() {
    this.swPU = true;
    this.swDO = true;
    this.pudoAnimation(true, 'PU');
    this.pudoAnimation(true, 'DO');
  }
  private createRangeHours(startHour: number, maxHour: number, range: number) {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    const datas = [];
    for (let i = startHour; i <= maxHour; i++) {
      datas.push(this.addZero(date.getHours()) + ':' + this.addZero(date.getMinutes()));
      date.setMinutes(date.getMinutes() + range);
    }
    return datas;
  }
  private addZero(i) {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  }
  protected onResponseStatus(event) {
    if (this.notesComponents) {
      this.notesComponents.reloadData();
    }
    if (event.success) {
      this.changeStatusPopup.close();
      this.reloadGrids.emit(false);
      if (this.isUnprocessedClaims) {
        this.ProvidersBillingService.ReloadGridUnprocess$.emit(true);
      }
      setTimeout(() => {
        if (this.nextReload) {
          this.reloadTrips.emit(this.model.tripid);
          this.iscancelreason = event.newValue === 7;
        }
      }, 4000);
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error',
        text: event.message,
        type: 'error'
      });
    }
  }

  private onResponseVehicleDriver(event) {
    if (event.success || event.result) {
      this.assignDriverVehiclePopover.close();
      this.toastrAlertHelper.success(event.message);
      if (this.isStandingOrder) {
        this.updateSo.emit(true);
      }
    } else {
      this.sweetAlertHelper.createCustomAlert({
        text: event.message,
        type: 'error',
      });
      this.assignDriverVehiclePopover.close();
    }
  }
  protected onClickCompleteBtn(event) {
    this.completeStatusPopup.open(event);
  }
  onClickStatusBtn(eve) {
    this.changeStatusPopup.openRef = eve;
    this.changeStatusPopup.open();
    this.assignDriverVehiclePopover.close();
    this.changeProviderPopup.close();
  }
  onClickChangeDriverBtn(eve) {
    const totalmiles = this.model.totalmiles;
    const calltypeid = this.reservationForm.get('calltypeid').value;
    // calltypeid == 6 Paramedic

    if (totalmiles || calltypeid === 6) {
      this.assignDriverVehiclePopover.openRef = eve;
      this.assignDriverVehiclePopover.open(event);
      this.changeStatusPopup.close();
      this.changeProviderPopup.close();
    } else {
      this.sweetAlertHelper.createCustomAlert({
        text: 'This trip has no miles, please check the pick or destination.',
        type: 'warning' ,
      });
    }
  }
  protected onClickProviderChangeBtn(event) {
    if (!this.isStandingOrder) {
      if (this.reservationID.providerstatusid === 3) {
        this.toastrAlertHelper.warning('This trip has been assigned to a provider');
        return false;
      }
    }

    this.changeProviderPopup.open(event);
    this.changeStatusPopup.close();
    this.assignDriverVehiclePopover.close();
  }
  public setStatusFromStatusManager(status) {
    this.reservationForm.patchValue({
      tripstatusid: status
    });
    this.reloadGrids.emit();
    this.reloadTrips.emit(this.model.tripid);
  }
  private setTwoNumberDecimal(event) {
    const totalamountlyft = this.reservationForm.get('totalamountlyft').value;
    this.reservationForm.patchValue({
      totalamountlyft: parseFloat(totalamountlyft).toFixed(2)
    });

    this.getTotalAmount();
  }
  protected onBrokerChange() {
    this.getTotalAmount();
  }
  private loadFacilityInfo(data: any) {
    if (!data) {
      return;
    }
    try {
      if (data.facility) {
        const facilityid =  inObject(data, 'facility.facilityid') ? data.facility.facilityid : '';
        const description = inObject(data, 'facility.description') ? data.facility.description : '';
        this.model.facilityid = facilityid;
        this.model.facilitydescription = description;
      } else {
        this.model.facilitydescription = null;
      }
    } catch (error) {
      throw new Error (JSON.stringify({
        function: 'loadFacilityInfo',
        error: error,
        data: data
      }));
    }
  }
  public onResponseCompleteStatus(event) {
    if (event.success) {
      this.toastrAlertHelper.success(event.message);
      this.completeStatusPopup.close();
    } else {
      this.toastrAlertHelper.error(event.message);
    }
  }
  openAppRidersCreate(event) {
    this.isOpenAppRidersCreate = event;
    this.emitterOpenAppRidersCreate.emit(this.isOpenAppRidersCreate);
  }
  sendTripToMCT() {
    const data = [{
      tripid: this.reservationForm.get('tripid').value,
      authorization: this.dhpAuth
    }];
    this.observables.push(
      this.service.sendTripToMCT(data).subscribe(
        () => {
          this.toastrAlertHelper.success('Trip sent successfully');
        },
        error => {
          this.toastrAlertHelper.error(error.message);
        }
      ));
  }
  getReportClaims() {

    const tripid = this.reservationForm.get('tripid').value;
    this.tripId = tripid;

  }
  getProviderPhone() {
    // Modificacion para motrar datos de provider
    this.providerPhone = this.companies.find((f) => f.companyid === this.reservationForm.get('companyid').value);
  }
  errorTotalMiles() {
    this.sweetAlertHelper.createCustomAlert({
      text: 'There is a conflict related to the mileage, edit trip and save to recalculate',
      type: 'error',
    });
  }
  isToday(date: any) {
    return moment(date).format('YYYY-MM-DD') === moment(new Date()).format('YYYY-MM-DD');
  }
  onSelectedFacility(data: any) {
    this.reservationForm.patchValue({
      'facilitydesc': data.location,
      'facilityid': data.facilityid
    });
  }
  getDataCompany() {
    try {
      let company: any;
      if (Array.isArray(this.brokers)) {
        company = this.brokers.filter(element => {
          if (element.brokerid === this.reservationForm.get('brokerid').value) {
            return element;
          }
        })[0];
      }
      if (company) {
        return company.hasOwnProperty('speedcode') ? company.speedcode : '';
      } else {
        return '';
      }
    } catch (error) {
    }
  }

  /**@name onDeleteModifierdEqual
   * @description elimina modifierid duplicado del address.
   * @param type = tipo de location.
   */
  onDeleteModifierdEqual(type: string) {
    const pk =  this.reservationForm.get('triplocationpickup').value;
    const dp =  this.reservationForm.get('triplocationdropoff').value;
    if (Object.keys(pk).length && Object.keys(dp).length && this.requiredModifier) {
      if (pk.modifierid === dp.modifierid) {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Duplicate Modifier',
          // text: `In the lag ${this.reservationForm.get('leg').value} the modifiers are equal.`,
          text: 'The modifiers are the same.',
          type: 'warning',
          confirmButtonText: 'Accept',
        });
        const address = this.reservationForm.get(type).value;
        address.modifierid = '';
        this.reservationForm.get(type).setValue(address);
      }
    }
  }

  modifierHasChanged(event: any) {
    if (this.requiredModifier) {
      if (this.reservationForm.get('tripstatusid').value !== 6 && this.reservationForm.get('tripstatusid').value !== 7) {
        if (this.reservationForm.get('triplocationpickup') && this.reservationForm.get('triplocationdropoff')) {
          if (this.reservationForm.get('triplocationpickup').value && this.reservationForm.get('triplocationdropoff').value) {
            if (this.reservationForm.get('triplocationpickup').value.modifierid &&
              this.reservationForm.get('triplocationdropoff').value.modifierid) {
              if (this.reservationForm.get('triplocationpickup').value.modifierid ===
                this.reservationForm.get('triplocationdropoff').value.modifierid) {
                this.sweetAlertHelper.createCustomAlert({
                  title: 'Modifier Duplicate',
                  text: `In the leg ${this.reservationForm.get('leg').value} the modifiers are equal.`,
                  type: 'warning',
                  showCancelButton: false,
                  confirmButtonText: 'Accept',
                });
              }
            }
          }
        }
      }
    }
  }
  onChangeBillingStatus(event) {
    if (event.success.includes(this.model.tripid)) {
      this.model['billingstatusid'] = event.status;
    }
  }
  onChangeProvider($event) {
    if (this.isStandingOrder) {
      this.updateSo.emit(true);
    }
  }
  setMedicalTrip() {
    if (this.model.medicaltrip) {
      this.NatureIdModel = this.model.medicaltrip.natureid;
      this.PriorityIdModel = this.model.medicaltrip.priorityid;
    }
  }
  viewCropper() {
    if (this.reservationForm.value.signaturephoto) {
      this.imageSignature = this.reservationForm.value.signaturephoto;
      return true;
    }
    if (this.reservationForm.get('tripreasonsignid').value === 5) {
      return true;
    }
  }

  /**@name assignServiceProv
   *@description organiza data y abre modal
   * @param event = address
   */
  private assignServiceProv(event: IDropoffServiceProvider)  {
    this.reservationForm.patchValue({ serviceproviderid: event.serviceproviderid });
    if (event.serviceproviderid) {
      event.location = event.description;
      this.addressSP = event;
      this.addressServiceProv.open();
    }
  }

  /**@name assignAddressSP
   *@description preguta y asigna dropoff o Pickup del service provider
   * @param type = tipo de address
   */
  assignAddressSP(type: string) {
    this.reservationForm.get(type).patchValue(this.addressSP);
    this.addressServiceProv.close();
    switch (type) {
      case 'triplocationpickup': this.onEpandPU();
        break;
      case 'triplocationdropoff': this.onEpandDO();
        break;
    }
    this.calculateEstimatedTime();
  }

  validShowReason(payorid: number): void {
    if (this.isWebApp) {
     this.getTripReasons(payorid);
    }
  }

  /**
   * @description trae las razones
   */
  private getReasosnsDelay(): void {
    this.observables.push(this._reasonDelayService.getReasons().subscribe(
      (reasons: IReasonDelay[]) => {
        this.reasonsDelay = assignNewArray(reasons);
      },
      error => {}
    ));
  }
  public disabledReasonsDelay(): boolean {
    return this.permissions.reasonForDelay && (this.viewReasonPU || this.viewReasonDO);
  }
  public requiredReasonDelay(): void {
    this.onValidateInputTime();
  }
  /**
   * @description valida calltype seleccionado en el array de calltypes
   * @param selected (selecionado antes de cambial el array)
   */
  private validCallTypeOfPayor(selected: ICallTypeResponse ): void {
    if (!this.getCallTypeSelected() && selected) {
      const data: ICallTypeResponse = {} as ICallTypeResponse;
      data.description = selected.description;
      data.disabled = true;
      data.calltypeid = null;
      this.calltypes.push(data);
      this.reservationForm.patchValue({
        calltypeid: null
      });
    }
  }
  /**
   * @description retorna calltype seleccionado
   */
  getCallTypeSelected(): ICallTypeResponse {
    let calltype: ICallTypeResponse = undefined;
    if (this.reservationForm.get('calltypeid').value && this.calltypes.length) {
      calltype = this.calltypes.find((f: ICallTypeResponse) => f.calltypeid === this.reservationForm.get('calltypeid').value);
    }
    return calltype;
  }
  /**
   * @description actualizar trips
   */
  public updateTrips(tripId?: number): void {
    this.observables.push(this.service.getTripById(tripId).subscribe(
      (response) => {
        this.reloadForm(response);
      }
    ));
  }

  onOpenProviderBillingModal() {
    if (this.isAllowedAction('EditProviderBilling') && !this.disabledBillingButtons) {
      this.providerBillingModal.open();
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error!',
        text: `You don't have permission to perform this action`,
        type: 'error',
      });
    }
  }

  onCLoseProviderBillingModal(reload: boolean) {
    this.providerBillingModal.close();
    if (reload) {
      if (this.reservationModule) {
        this.reloadTrips.emit(this.model.tripid);
      } else if (this.isStandingOrder) {
        this.updateSo.emit(true);
      } else {
        this.initialLoader();
      }
    }
  }

  onCLoseClientBillingModal(reload: boolean) {
    this.clientBillingModal.close();
    if (reload) {
      if (this.reservationModule) {
        this.reloadTrips.emit(this.model.tripid);
      } else if (this.isStandingOrder) {
        this.updateSo.emit(true);
      } else {
        this.initialLoader();
      }
    }
  }

  onOpenClientBillingModal() {
    if (this.isAllowedAction('EditClientBilling') && !this.disabledBillingButtons) {
      this.clientBillingModal.open();
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error!',
        text: `You don't have permission to perform this action`,
        type: 'error',
      });
    }
  }

  onValidateInputTime() {
    const arrayInput = ['appointment', 'activationtime', 'pickup', 'actualpickup', 'scheduleddropofftime', 'actualdropoff', 'noshowtime'];
    let value; let sw = false;
    arrayInput.filter((item) => {
      value = this.reservationForm.get(item).value;
      if (value && value.replace(/[^0-9]/g, '').length < 4) {
        sw = true;
        this.validateTime.emit(true);
      }
    });
    if (!sw) {
      this.validateTime.emit(false);
    }
  }

  openChangeTimeModal() {
    if (!this.isAllowedAction('EditChangeTimeSo')) {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error!',
        text: `You don't have permission to perform this action`,
        type: 'error',
      });
      return;
    }
    this.newReservationService.reservationData$.next(this.reservationForm.value);
    this.newReservationService.standingOrderDate$.next(this.standingOrderDate);
    this.changeTimeModal.open();
  }

  saveChangeTime(save: boolean) {
    if (save) {
      this.updateSo.emit(true);
    }
    this.changeTimeModal.isOpen ? this.changeTimeModal.close() : null;
  }

  get showButtonSendProvider(): boolean {
    return (
       !this.isClientUser &&
        this.verifySendProviders() &&
        (this.permissions.sendToLyft ||
      this.permissions.sendToUber)
    );
  }

  verifySendProviders(): boolean {
    let isSend = false;
    const providerid = this.reservationForm.get('companyid').value;
    if (providerid) {
      switch (providerid) {
        case CompaniesEnum.Lyft:
          isSend = true;
          break;
        case CompaniesEnum.Uber:
          isSend = true;
          break;
      }
    }
    return isSend;
  }

  emiitEventPhone(event, nameLocation: string) {
    nameLocation === 'Pickup' ? this.disabledPickup = event.phoneNumber  : this.disabledDrop = event.phoneNumber ;
    this.disabledPickup || this.disabledDrop ? this.disbledSaveByPhone = true : this.disbledSaveByPhone = false;
  }

  get reservationGoogleOrdr(): string {
    return this.reservationForm.get('googleordrguid').value
  }

  get disabledBillingButtons(): boolean {
    return this.reservationForm.get('tripstatusid').value === TripStatusEnum.Cancelled;
  }

  get reservationIsComplete(): boolean {
    return this.reservationForm.get('tripstatusid').value === TripStatusEnum.DropOff;
  }

  get getIsOpenAppRidersCreate(): boolean {
    return this.isOpenAppRidersCreate && !!this.model && !!this.model.riderid;
  }

  get isTrip2Tenant(): boolean {
    return getCurrentUser().tenant === TenantsEnum.trip2;
  }

  get rescuenetNumberCtrl(): AbstractControl {
    return this.reservationForm.get('rescuenetnumber');
  }

  get isValidRescuenetNumberCtrl(): boolean {
    const VAL = this.model.rescuenetnumber;
    return VAL === null || VAL === undefined;
  }

  get queryTripId(): number {
    return typeof this.reservationID === 'number' ? this.reservationID : this.reservationID.tripid;
  }

  get invalidReasons(): boolean {
    return this.reasonsTransportInvalid.length ? true : false;
  }

  get DisabledBtnSave(): boolean {
    return (!this.reservationForm.valid && !this.sw) || this.onApplyingRules || this.disbledSaveByPhone;
  }

  get clientUserAndTripStatus(): boolean {
    return (this.isClientUser && this.reservationForm.get('tripstatusid').value !== 7) || !this.isClientUser;
  }

  get authorizationStatus(): string {
    const totalMiles = this.reservationForm.get('totalmiles').value;
    const authorizationStatus = this.reservationForm.get('authorizationstatusdesc').value;
    return `Authorization ${totalMiles > Miles.Authorization ? authorizationStatus : ''}`;
  }

  get styleAuthorizationLabel(): string {
    const payorsId = [PayorEnum.SimplyMMA, PayorEnum.SimplyMCR, PayorEnum.SimplyFHK, PayorEnum.SimplyClear,
    PayorEnum.FloridaCommunityCare];
    const totalMiles = this.reservationForm.get('totalmiles').value;
    const payorIdValue = this.reservationForm.get('payorid').value;
    const isPayor = payorsId.includes(payorIdValue);
    if (isPayor && totalMiles > Miles.Authorization) {
      const authorizationStatus = this.reservationForm.get('authorizationstatusdesc').value;
      const status = {
        'Pending': 'color-orange',
        'In Progress': 'color-progress',
        'Approved': 'color-success',
        'Denied': 'color-danger',
      };
      return status[authorizationStatus];
    }
    return 'color-black';
  }

  get payorAuthorizationValue(): string {
    return this.reservationForm.get('payorauthorization').value;
  }

  get disabledAuthorization(): boolean {
    return this.isAllowedAction('AuthorizationEnabled');
  }

  get providerPhoneNumber(): string {
    if (this.providerPhone && this.providerPhone.phonenumber) {
      return this.providerPhone.phonenumber;
    }
  }

  get providerDescription(): string {
    if (this.providerPhone && this.providerPhone.description) {
      return this.providerPhone.description;
    }
  }

  get getOperationEmail(): string {
    if (
      this.informationTrip &&
      this.informationTrip.company &&
      this.informationTrip.company.operationsemail
    ) {
      return this.informationTrip.company.operationsemail;
    }
  }

  get validateTripIdForNewLeg (): boolean {
    return typeof this.reservationID !== 'number' && this.reservationID.tripid === 0;
  }

  get formReservationId(): number {
    return this.reservationForm.get('reservationid').value;
  }

  getCountLegsReservation(): void {
    this.numberOfLegs = 1;
    if (this.formReservationId) {
      this.service.getCountLegsReservation(this.formReservationId).subscribe(
        data => {
          this.numberOfLegs = data;
        }
      );
    }
  }

  get isExceedsOrEqual50Miles(){
    return this.reservationForm.get('totalmiles').value >= 50
  }

  validPickupImpl(time: string): void {
    const isValid = ValidateTimesHelper.validPickup({
      time: time,
      pickup: this.reservationForm.get('pickup').value,
      addedon: this.reservationForm.get('addedon').value,
      dateofservice: this.reservationForm.get('dateofservice').value,
      currentLeg: this.getCurrentLeg.value
    });

    let actualDropOff = this.reservationForm.get('actualdropoff').value;
    if (actualDropOff === null) { actualDropOff = ''; }

    this.viewReasonPU = isValid;

    if (isValid) { this.requiredReasonDelay(); }

    if (this.viewReasonPU && this.triplatereasonCtrl.value !== '' && this.triplatereasonCtrl.value !== null ) {
      this.triplatereasonCtrl.patchValue(null);
    }
  }

  validDropOffImpl(time: string): void {
    const isValid = ValidateTimesHelper.validDropOff({
      time: time,
      pickup: this.reservationForm.get('pickup').value,
      addedon: this.reservationForm.get('addedon').value,
      dateofservice: this.reservationForm.get('dateofservice').value,
      currentLeg: this.getCurrentLeg.value,
      appointmentCurrent: this.reservationForm.get('appointment').value
    });

    let actualPickUp = this.reservationForm.get('actualpickup').value;
    if (actualPickUp === null) { actualPickUp = ''; }

    this.viewReasonDO = isValid;

    if (this.viewReasonDO && this.triplatereasonCtrl.value !== '' && this.triplatereasonCtrl.value !== null ) {
      this.triplatereasonCtrl.patchValue(null);
    }
  }

  eventEmiterSelectedTab(numberTab: number, nameTab: string) {
    this.newReservationService.tabSelectedSubject$.next({ numberTab, nameTab });
  }

  openModalDriverManifest(): void {
    this.driverManifest.open();
    this.newReservationService.isManifestReview.next({ reviewmanifest: true });
  }

  openModalSignature(): void {
    if (this.isReasonMissing) {
      return;
    }
    this.newReservationService.setReadOnly(this.sw);

    if (this.reservationForm.get('tripreasonsignid').value) {
      this.getSelectedReason();
    }
    if (this.signatureModal) {
      this.signatureModal.open();
    }
  }

  get isReasonMissing(): boolean {
    const formValue = this.reservationForm.value;
    return this.sw && (!formValue || !formValue.tripreasonsignid);
  }

  get isTripSwitchesDisabled(): boolean {
    return !!this.sw;
  }

  getSelectedReason() {
    const id = this.reservationForm.get('tripreasonsignid').value;
    const reason = this.reasonSigns.find((r) => r.tripreasonsignid === id);

    this.selectedReasonDescription = reason.description || '';
  }

  get isTabEdiFileHistory(): boolean {
    return this.tab === TabsReservationEnum.EdiFileHistory;
  }

  permissionEncounterHistory() {
    const payorid = this.reservationForm.get('payorid').value;
    let payor: { payor: { encountertype: null; }; };
    if (payorid) {
      payor = this.payors.find(f => f.payorid === payorid);
    }
    const payorValid = [
      EncounterTypeEnum.ApprovedEncounter,
      EncounterTypeEnum.GeneratesEncounter,
    ];
    const validationEncounterType = payor.payor.encountertype ? payor.payor.encountertype : null;
    const isValid = this.permissions.encounterHistory && payorValid.includes(validationEncounterType);
    this.isEncounterHistory = isValid;
  }

  sendEncounterModel() {
    const tripId = this.reservationForm.get('tripid').value;
    if (tripId) {
      const tripPaymentDate = this.model && this.model.trippaymentsdateformatted ? this.model.trippaymentsdateformatted : '';
      const encounterStatus = this.model && this.model.encounterstatus ? this.model.encounterstatus.description : '';
      const planType = this.model && this.model.reservation ? this.model.reservation.plantype : '';
      const region = this.model && this.model.reservation ? this.model.reservation.region : '';

      this.service.setEncounterData({
        tripId: tripId,
        tripPaymentDate: tripPaymentDate,
        encounterStatus: encounterStatus,
        planType: planType,
        region: region,
        showButton: this.permissions.setPlanTypeAndRegion,
      });
    }
  }

  private removeFromGroup(): void {
    const tripId = this.reservationForm.get('tripid').value;
    if (!tripId) {
      return;
    }

    if (this.connection) {
      this.observables.push(
        this.signalRlisten
          .deleteHubConnection(constant.URL_HUB_EDIT_RESERVATION, tripId)
          .subscribe({
            next: () => {},
            error: (error) => {
              this.sweetAlertHelper.captureException(error);
            },
          }),
      );
    }
  }

  ngOnDestroy() {
    this.removeFromGroup();
    if (!this.isStandingOrder) {
      this.observables.push(this.service.putEnableTripForm(this.model.tripid).subscribe());
    }
    this.signalRlisten.unsubscribeTo(this.editReservationHubConnection);
    this.timers.forEach((item) => {
      clearTimeout(item);
    });
    setTimeout(() => {
      this.observables.forEach((item) => item.unsubscribe());
    }, 4000);
  }

  openReport() {
    const modelGenericReport: IOpenReport = {
      numberReport: ReportsIdEnum.driver_manifest,
      bodyRequestReport: {
        parameters: {
          TripId: this.tripId,
        }
      }
    };
    this.genericReportingService.openGenericReport(modelGenericReport);
  }

  getStandingOrderTrips() {
    this.observables.push(
      this.service.standingOrderTrips$.subscribe({
        next: (data: any) => {
          if (data) {
            this.standingOrderTrip = data;
          }
        },
      })
    );
  }

  get isNegotiatedRate (): boolean {
    if (this.isStandingOrder) {
      this.currentStandingOrder = this.standingOrderTrip.find(
        (f: { leg: AbstractControl }) =>
          f.leg === this.getCurrentLeg.value
      );
    }
    return this.isStandingOrder ? this.currentStandingOrder.isclientnegotiated : this.reservationForm.get('isnegotiatedrate').value;
  }

  onChangeReasonTransport() {
    const payorId = this.reservationForm.get('payorid').value;
    if (
      this.reservationForm &&
      this.reservationForm.get('tripreasontransportid').value
    ) {
      const tripReasonTransportId = this.reservationForm.get(
        'tripreasontransportid'
      ).value;
      this.ValidationsTripService.onChangeReasonTransport(payorId, tripReasonTransportId);
    }
  }

  downloadBillingReport() {
    if (this.permissions && this.permissions.downloadBillingReport) {
      const tripId = this.reservationForm.get('tripid').value;
      if (tripId) {
        const parameters: IParametersOpenReport = {
          TripId: tripId,
        };
        const tripBillingReport: IOpenReport = {
          numberReport: ReportsIdEnum.trip_billing,
          bodyRequestReport: {
            parameters: parameters,
          },
        };
        this.genericReportingService.openGenericReport(tripBillingReport);
      }
    }
  }

  openPaymentReceiptModal(): void {
    if (!this.showButtonPaymentReceipt) {
      return;
    }
    this.paymentReceiptSelectedFileName = '';
    this.paymentReceiptUploadFile = null;
    this.clearPaymentReceiptPreview();
    this.paymentReceiptModal.open();
    this.loadPaymentReceiptByTripId();
  }

  private loadPaymentReceiptByTripId(): void {
    const tripId = this.reservationForm.get('tripid').value;
    if (!tripId) {
      return;
    }
    this.paymentReceiptLoading = true;
    this.observables.push(
      this.service
        .getTripPaymentReceiptByTripId(tripId)
        .finally(() => {
          this.paymentReceiptLoading = false;
        })
        .subscribe({
          next: (data: string) => {
            if (data) {
              this.setPaymentReceiptPreview(data);
            }
          },
          error: (error) => {
            this.clearPaymentReceiptPreview();
            this.sweetAlertHelper.captureException(error);
          },
        }),
    );
  }

  private clearPaymentReceiptPreview(): void {
    this.paymentReceiptLoading = false;
    this.setPaymentReceiptPreview('');
  }

  private setPaymentReceiptPreview(attachment: string): void {
    this.paymentReceiptAttachment = attachment ? attachment : '';
    this.paymentReceiptFrameUrl = this.paymentReceiptAttachment
      ? this.sanitizer.bypassSecurityTrustResourceUrl(
          this.paymentReceiptAttachment,
        )
      : null;
  }

  triggerPaymentReceiptUpload(inputFile: HTMLInputElement): void {
    if (!inputFile || this.paymentReceiptUploading) {
      return;
    }
    inputFile.click();
  }

  uploadPaymentReceiptFile(event: { target: any; srcElement: any; }): void {
    const target = event.target;
    const srcElement = event && event.srcElement ? event.srcElement : target;
    const file =
      target && target.files && target.files.length ? target.files[0] : null;
    if (!file) {
      return;
    }

    if (file.type && !this.isValidPaymentReceiptMimeType(file.type)) {
      this.sweetAlertHelper.captureException(
        'The file type is invalid. Only PDF is allowed',
      );
      this.paymentReceiptSelectedFileName = '';
      this.paymentReceiptUploadFile = null;
      if (srcElement) {
        srcElement.value = '';
      }
      return;
    }
    this.paymentReceiptSelectedFileName = file.name;
    this.paymentReceiptUploadFile =
      srcElement && srcElement.files ? srcElement.files : target.files;
  }

  savePaymentReceiptFile(inputElement: { value: string }): void {
    if (this.isPaymentReceiptSaveDisabled) {
      return;
    }
    this.startUploadPaymentReceipt(inputElement);
  }

  private isValidPaymentReceiptMimeType(mimeType: string): boolean {
    const validMimeType = ['application/pdf'];
    return validMimeType.includes(mimeType);
  }

  private startUploadPaymentReceipt(inputElement?: { value: string }): void {
    const tripIdValue = this.reservationForm.get('tripid').value;
    if (!this.hasPaymentReceiptSelectedFile) {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Attention',
        type: 'info',
        text: 'Please, choose a file',
      });
      return;
    }

    if (!tripIdValue) {
      this.toastrAlertHelper.error(
        'Trip is not valid for payment receipt upload',
      );
      this.paymentReceiptUploadFile = null;
      this.paymentReceiptSelectedFileName = '';
      if (inputElement) {
        inputElement.value = '';
      }
      return;
    }

    const params = [{ nameParam: 'tripid', data: tripIdValue }];

    this.paymentReceiptUploading = true;
    this.loading.show('Uploading payment receipt');

    this.observables.push(
      this.uploadService
        .makeFileRequest(
          constant.URL_TRIP_PAYMENT_RECEIPT_UPLOAD,
          params,
          this.paymentReceiptUploadFile,
          'file',
        )
        .finally(() => {
          this.paymentReceiptUploading = false;
          this.loading.hiden();
        })
        .subscribe({
          next: (response: any) => {
            if (response && response.message) {
              this.toastrAlertHelper.success(response.message);
            }
            this.loadPaymentReceiptByTripId();
            this.paymentReceiptUploadFile = null;
            this.paymentReceiptSelectedFileName = '';
            if (inputElement) {
              inputElement.value = '';
            }
          },
          error: (error) => {
            this.sweetAlertHelper.captureException(error);
            if (inputElement) {
              inputElement.value = '';
            }
          },
        }),
    );
  }

  private canShowPaymentReceiptByCompany(): boolean {
    const tripCompanyId = this.getTripCompanyId();
    if (!tripCompanyId || !this.companies) {
      return false;
    }
    const company = this.companies.find(
      (item) => item.companyid === tripCompanyId,
    );
    return !!(company && company.isprepaid);
  }

  private getTripCompanyId(): number | null {
    const formControl =
      this.reservationForm && this.reservationForm.get('companyid');
    if (formControl && formControl.value) {
      return formControl.value;
    }
    if (this.model && this.model.companyid) {
      return this.model.companyid;
    }
    return null;
  }

  get showProviderPhone() {
    return !this.isClientUser || (this.isClientUser && this.permissions.showProviderPhone);
  }

  get showDriverPhone() {
    return !this.isClientUser || (this.isClientUser && this.permissions.showDriverPhone);
  }

  isTabSelected(tab: EditReservationEnum): boolean {
    if (tab === EditReservationEnum.Claims) {
      return this.tab === tab && this.isTrip2Tenant;
    } else if ([EditReservationEnum.Notes, EditReservationEnum.History, EditReservationEnum.Survey].includes(tab)) {
      return this.tab === tab && !this.isStandingOrder;
    }
    return this.tab === tab;
  }

  get showButtonReceipt(): boolean {
    return this.permissions.downloadBillingReport && this.isTabSelected(EditReservationEnum.Billing);
  }

  get showButtonPaymentReceipt(): boolean {
    return (
      this.permissions.paymentReceiptUpload &&
      this.isTabSelected(EditReservationEnum.Billing) &&
      this.canShowPaymentReceiptByCompany()
    );
  }

  get hasPaymentReceiptSelectedFile(): boolean {
    const hasFileName = !!this.paymentReceiptSelectedFileName;
    const hasFileList = !!(this.paymentReceiptUploadFile && this.paymentReceiptUploadFile.length);
    return hasFileName && hasFileList;
  }

  get isPaymentReceiptSaveDisabled(): boolean {
    return this.paymentReceiptUploading || !this.hasPaymentReceiptSelectedFile;
  }

  get paymentReceiptUploadButtonText(): string {
    return this.paymentReceiptAttachment ? 'Update Receipt' : 'Upload Receipt';
  }

  get showPaymentReceiptPreviewSection(): boolean {
    return !this.paymentReceiptLoading && !!this.paymentReceiptAttachment;
  }

  get showPaymentReceiptEmptySection(): boolean {
    return !this.paymentReceiptLoading && !this.paymentReceiptAttachment;
  }

  get paymentReceiptSelectedFileText(): string {
    return this.paymentReceiptSelectedFileName || 'No file selected';
  }

  get showButtonSendTracking(): boolean {
    const allowedStatus = [TripStatusEnum.OnMyWay, TripStatusEnum.Arrived, TripStatusEnum.PickUp];
    return allowedStatus.includes(this.reservationForm.value.tripstatusid) &&
      this.isTabSelected(EditReservationEnum.Route) &&
      this.permissions.sendTracking;
  }

  get validateAdminUser(): boolean {
    return this.currentUser && this.currentUser.roleid === RoleEnum.Admin;
  }

  disabledPayor(riderPayor: IRiderPayor): boolean {
    return !this.validateAdminUser && (!riderPayor.isactive || !riderPayor.payor.isactive);
  }

  sendTripTracking(): void {
    const tripId: number = this.reservationForm.get('tripid').value;
    if (tripId) {
      this.service.sendTripTrackingToTheRider(tripId).subscribe({
        next: (resp) => {
          this.sweetAlertHelper.createCustomAlert({
            title: 'Success',
            text: resp.message,
            type: 'success',
            confirmButtonText: 'Accept',
          });
        },
        error: (error) => {
          this.sweetAlertHelper.captureException(error);
        }
      });
    }
  }
}

export const enum Miles {
  Authorization = 50
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/edit-reservation-form/edit-reservation-form.component.ts